module.exports = __webpack_public_path__ + "img/solar.826f13ba.png";